/**
 * Created by vsliwka on 20/04/2017.
 */
export class WorkThemeModel {
  public id: number;
  public label: string;
  public principalTheme: number;
  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
